import { render, staticRenderFns } from "./GSelectConsultor.vue?vue&type=template&id=8c3c55b8"
import script from "./GSelectConsultor.vue?vue&type=script&lang=js"
export * from "./GSelectConsultor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports